(function() {
  'use strict';

  angular
    .module('NozzleSelector.services')
    .factory('dataService', dataService);

  /* @ngInject */
  function dataService() {

    var units = {
      applicationRate: [{
        abbr: 'GpA',
        label: 'units.gpa.label',
        formulaConstant: 5940, // fixed for the application
        spacingDefault: 'inches',
        isMetric: false,
        min: 10,
        max: 200
      }, {
        abbr: 'GpT',
        label: 'units.gpt.label',
        formulaConstant: 136,
        spacingDefault: 'inches',
        isMetric: false,
        min: 0.3,
        max: 5.5
      }, {
        abbr: 'LpH',
        label: 'units.lph.label',
        formulaConstant: 60000,
        spacingDefault: 'cm',
        isMetric: true,
        min: 50,
        max: 2300
      }],
      groundSpeed: [{
        abbr: 'MpH',
        label: 'units.mph.label',
        isMetric: false,
        min: 2.5,
        max: 6
      }, {
        abbr: 'Km/h',
        label: 'units.kmph.label',
        isMetric: true,
        min: 4,
        max: 14
      }],
      spacing: {
        'inches' : {
          abbr: '\"',
          label: 'inches',
          isMetric: false,
          value: 20 // fixed for the application
        },
        'cm':  {
          abbr: 'cm',
          label: 'cm',
          isMetric: true,
          value: 50
        }
      }
    };

    var nozzleTypesMatrix = [{
      name: 'AIC',
      nameToTranslate: 'nozzles.names.aic',
      contact: 'good',
      systemic: 'excellent',
      driftControl: 'excellent',
      description: 'nozzles.descriptions.aic'
    }, {
      name: 'AI Turbo TwinJet',
      nameToTranslate: 'nozzles.names.twinjet',
      contact: 'excellent',
      systemic: 'good',
      driftControl: 'good',
      description: 'nozzles.descriptions.twinjet'
    }, {
      name: 'TurfJet',
      nameToTranslate: 'nozzles.names.turfjet',
      contact: 'poor',
      systemic: 'excellent',
      driftControl: 'excellent',
      description: 'nozzles.descriptions.turfjet'
    }, {
      name: 'XRC',
      nameToTranslate: 'nozzles.names.xrc',
      contact: 'excellent',
      systemic: 'good',
      driftControl: 'poor',
      description: 'nozzles.descriptions.xrc'
    }];

    var nozzles = {
      'red' : [{
        name: 'AIC',
        partNumber: '120-0701',
        image: 'Red_AIC_120-0701.png',
        strainer: 50,
        mesh: [80]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0708',
        image: 'Red_TwinJet_Turbo_120-0708.png',
        strainer: 50,
        mesh: [80]
      }, {
        name: 'TurfJet',
        partNumber: '95-9222',
        image: 'Red_TurfJet_95-9222.png',
        strainer: 50,
        mesh: [80]
      }, {
        name: 'XRC',
        partNumber: '117-5834',
        image: 'Red_XRC_117-5834.png',
        strainer: 50,
        mesh: [80]
      }],
      'brown' : [{
        name: 'AIC',
        partNumber: '120-0709',
        image: 'Brown_AIC_120-0702.png',
        strainer: 50,
        mesh: [80, 50]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0709',
        image: 'Brown_TwinJet_Turbo_120-0709.png',
        strainer: 50,
        mesh: [80, 50]
      }, {
        name: 'TurfJet',
        partNumber: '95-9223',
        image: 'Brown_Turfjet_95-9223.png',
        strainer: 50,
        mesh: [80, 50]
      }, {
        name: 'XRC',
        partNumber: '117-5835',
        image: 'Brown_XRC_117-5835.png',
        strainer: 50,
        mesh: [80, 50]
      }],
      'gray' : [{
        name: 'AIC',
        partNumber: '120-0703',
        image: 'Gray_AIC_120-0703.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0710',
        image: 'Gray_TwinJet_Turbo_120-0710.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'TurfJet',
        partNumber: '95-9224',
        image: 'Gray_Turfjet_95-9224.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'XRC',
        partNumber: '117-5836',
        image: 'Gray_XRC_117-5836.png',
        strainer: 50,
        mesh: [50]
      }],
      'white' : [{
        name: 'AIC',
        partNumber: '120-0704',
        image: 'White_AIC_120-0704.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0711',
        image: 'White_Twinjet_Turbo_120-0711.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'TurfJet',
        partNumber: '95-9225',
        image: 'White_TurfJet_95-9225.png',
        strainer: 50,
        mesh: [50]
      }, {
        name: 'XRC',
        partNumber: '117-5837',
        image: 'White_XRC_117-5837.png',
        strainer: 50,
        mesh: [50]
      }],
      'blue' : [{
        name: 'AIC',
        partNumber: '120-0705',
        image: 'Blue_AIC_120-0705.png',
        strainer: 50,
        mesh: [50, 30]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0712',
        image: 'Blue_Twinjet_Turbo_120-0712.png',
        strainer: 50,
        mesh: [50, 30]
      }, {
        name: 'TurfJet',
        partNumber: '95-9188',
        image: 'Blue_Turfjet_95-9188.png',
        strainer: 50,
        mesh: [50, 30]
      }, {
        name: 'XRC',
        partNumber: '117-5838',
        image: 'Blue_XRC_117-5838.png',
        strainer: 50,
        mesh: [50, 30]
      }],
      'green' : [{
        name: 'AIC',
        partNumber: '120-0706',
        image: 'Green_AIC_120-0706.png',
        strainer: 50,
        mesh: [30]
      }, {
        name: 'AI Turbo TwinJet',
        partNumber: '120-0713',
        image: 'Green_Twinjet_Turbo_120-0713.png',
        strainer: 50,
        mesh: [30]
      }, {
        name: 'TurfJet',
        partNumber: '95-9226',
        image: 'Green_TurfJet_95-9226.png',
        strainer: 50,
        mesh: [30]
      }, {
        name: 'XRC',
        partNumber: '117-5839',
        image: 'Green_XRC_117-5839.png',
        strainer: 50,
        mesh: [30]
      }]
    };

    var filters = {
      80 : {
        partNumber: '100-6992',
        image: 'Suction_Filter_Red_Mesh80_100-6992.png'
      },
      50 : {
        partNumber: '100-8642',
        image: 'Suction_Filter_Blue_Mesh50_100-8642.png'
      },
      30 : {
        partNumber: '100-6991',
        image: 'Suction_Filter_Green_Mesh30_100-6991.png'
      }
    };

    var colorRanges = {
      'gpm': [{
        color: 'red',
        min: 0.28,
        perfect: 0.4,
        max: 0.53
      }, {
        color: 'brown',
        min: 0.35,
        perfect: 0.5,
        max: 0.66
      }, {
        color: 'gray',
        min: 0.42,
        perfect: 0.6,
        max: 0.79
      }, {
        color: 'white',
        min: 0.57,
        perfect: 0.8,
        max: 1.06
      }, {
        color: 'blue',
        min: 0.71,
        perfect: 1,
        max: 1.32
      }, {
        color: 'green',
        min: 1.06,
        perfect: 1.5,
        max: 1.98
      }],
      'lpm': [{
        color: 'red',
        min: 0.91,
        perfect: 1.29,
        max: 2.04
      }, {
        color: 'brown',
        min: 1.14,
        perfect: 1.61,
        max: 2.54
      }, {
        color: 'gray',
        min: 1.37,
        perfect: 1.94,
        max: 3.06
      }, {
        color: 'white',
        min: 1.82,
        perfect: 2.58,
        max: 4.08
      }, {
        color: 'blue',
        min: 2.28,
        perfect: 3.23,
        max: 5.10
      }, {
        color: 'green',
        min: 3.42,
        perfect: 4.83,
        max: 7.64
      }]
    };

    return {
      getUnits: function() { return units; },
      getNozzles: function() { return nozzles; },
      getFilters: function() { return filters; },
      getColorRanges: function() { return colorRanges; },
      getNozzleTypesMatrix: function() { return nozzleTypesMatrix; }
    };
  }

}());
